/* Copyright (C) 2020 Carlo Capuano - All Rights Reserved
 * You may use, distribute and modify this code under the
 * terms of the MIT license.
 */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OrganizationMedia } from '../autogenerated/model';

@Injectable({
  providedIn: 'root',
})
export class TemplateService {
  /**
   * I use this three behavior for add supplementary class or text into header, app and footer component.
   * Default is null but only in drone-single-stream component I need change or disable this three component.
   */

  public $headerClass = new BehaviorSubject<string>('');
  public $footerClass = new BehaviorSubject<string>('');
  public $activeComponent = new BehaviorSubject<string>('');
  public $media = new BehaviorSubject<OrganizationMedia>({});

  constructor() {}

  public pushToAll(cssClass: string) {
    this.$headerClass.next(cssClass);
    this.$footerClass.next(cssClass);
  }
}
